import * as signalR from "@microsoft/signalr"
import { v4 as uuidv4 } from "uuid"

export default defineNuxtPlugin(() => {
  console.log("defineNuxtPlugin()")

  const config = useRuntimeConfig()

  // Factory function to create new connections
  const createConnection = () => {
    const channelId = uuidv4()
    const hubUrl = `${config.public.signalrHubUrl}?channelid=${encodeURIComponent(channelId)}`

    const connection = new signalR.HubConnectionBuilder()
      .withUrl(hubUrl)
      .configureLogging(signalR.LogLevel.Information)
      .build()

    const start = async () => {
      console.debug("start()")
      try {
        if (connection.state === signalR.HubConnectionState.Disconnected) {
          await connection.start()
          console.log("✅ SignalR Connected.")
        }
      } catch (err) {
        console.error("❌ SignalR Connection Error:", err)
        setTimeout(start, 5000) // retry after 5s
      }
    }

    const stop = async () => {
      try {
        if (connection.state !== signalR.HubConnectionState.Disconnected) {
          await connection.stop()
          console.log("⚠️ SignalR Disconnected.")
        }
      } catch (err) {
        console.error("❌ Error stopping SignalR:", err)
      }
    }

    connection.onclose(async () => {
      console.debug("🔄 SignalR Connection Closed. Reconnecting...")
      await start()
    })

    const listen = (methodName: string, callback: (...args: any[]) => void) => {
      connection.on(methodName, callback)
    }

    const removeListener = (methodName: string, callback: (...args: any[]) => void) => {
      connection.off(methodName, callback)
    }

    const sendMessage = async (methodName: string, ...args: any[]) => {
      console.debug("sendMessage()")
      try {
        if (connection.state !== signalR.HubConnectionState.Connected) {
          await start()
        }
        await connection.invoke(methodName, ...[channelId, ...args])
      } catch (err) {
        console.error("❌ Error invoking method:", err)
      }
    }

    return {
      start,
      stop,
      sendMessage,
      listen,
      removeListener,
      connection
    }
  }

  // Expose the factory function directly
  return {
    provide: {
      signalR: createConnection,
    },
  }
})